import types from "./actionTypes";
import LoaderActions from "./loaderActions";
import Culture from "../../services/culture";

class cultureActions {

    static getAllLanguages() {
        return async function (dispatch) {
            dispatch(LoaderActions.startAsyncCall());
            try {
                const languages = await Culture.getAllLanguages();
                dispatch(cultureActions._getAllLanguages(languages));
            } catch (error) {
                dispatch(LoaderActions.errorAsyncCall());
                throw error;
            }
        };
    }

    static _getAllLanguages(languages) {
        return {
            type: types.CULTURE.SET_ALL_LANGUAGES,
            languages
        };
    }
}

export default cultureActions;
